module.exports = __webpack_public_path__ + "static/media/view4.8581bf4f.jpg";